export const getEmployeeExpensesSelector = (state) =>
  state.expensesReducer?.employeesExpenses;

export const getEmployeeSelectedExpenseSelector = (state) =>
  state.expensesReducer.selectedExpense;
